module.exports = __webpack_public_path__ + "media/packs/booking-system/appointment-booking/src/images/booking-img-step-3-c0418a8ce1f4f8478efd62ed7661838c.jpg";